/* src/app/components/billing/deposit-entry/deposit-entry-list/deposit-entry-list.component.css */
:host {
  --teal-head-text: #00504b;
  --teal-mid: #01796f;
  --teal-pale: #cff1ef;
  --teal-bright: #10b8ad;
  --meta-gray: #454545;
  --meta-value: #20242a;
  --lavender-tint: #bebdf575;
  --lavender-pale: #eeecfd;
  --green: #1e8a4c;
  --green-bg: #e8f6ed;
  --red: #c0392b;
  --red-bg: #fdeceb;
  --line: #d9d9d9;
  --line-eee: #eee;
  --mono-font:
    "Cascadia Code",
    "Consolas",
    "Courier New",
    monospace;
}
.dep-head.ppl-container-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.dep-head__titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dep-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.786rem;
  font-weight: 400;
  line-height: 1.2;
}
.dep-breadcrumb__link {
  color: var(--teal-mid);
  font-weight: 600;
  text-decoration: none;
}
.dep-breadcrumb__link:hover {
  text-decoration: underline;
}
.dep-breadcrumb__sep,
.dep-breadcrumb__current {
  color: var(--meta-gray);
}
.dep-title {
  margin: 0;
  color: var(--teal-head-text);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.15;
}
.dep-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 2.571rem;
  padding: 0.571rem 0.857rem;
  border-radius: 8px;
  font-size: 0.857rem;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid var(--line);
  transition: background-color 0.15s ease;
}
.dep-btn--ghost {
  background: #ffffff;
  color: #303030;
}
.dep-btn--ghost:hover {
  background: #f6f8f8;
}
.dep-btn--primary {
  background: var(--teal-head-text);
  color: #ffffff;
  border-color: var(--teal-head-text);
}
.dep-btn--primary:hover {
  background: var(--teal-mid);
}
.dep-tiles {
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  max-width: 960px;
}
.dep-tile {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #ffffff;
  border: 1px solid var(--line-eee);
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}
.dep-tile__label {
  align-self: flex-start;
  padding: 4px 6px;
  background: var(--lavender-tint);
  color: var(--meta-gray);
  border-radius: 4px;
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.dep-tile__value {
  font-size: 1.571rem;
  font-weight: 600;
  color: var(--teal-mid);
  line-height: 1;
}
.dep-tile__value--pos {
  color: var(--green);
}
.dep-tile__value--neg {
  color: var(--red);
}
.dep-panel {
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.dep-panel__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--teal-pale);
}
.dep-panel__title {
  margin: 0;
  font-size: 1.071rem;
  font-weight: 700;
  color: var(--teal-head-text);
}
.dep-panel__sum {
  margin-left: auto;
  font-size: 0.857rem;
  color: var(--meta-gray);
  font-weight: 400;
}
.dep-panel__body {
  padding: 16px;
  border-top: 1px solid var(--line-eee);
}
.dep-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 12px;
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.dep-tag--teal {
  background: #e2f6f4;
  color: var(--teal-mid);
  border: 1px solid #a8e0da;
}
.dep-tag--green {
  background: var(--green-bg);
  color: var(--green);
  border: 1px solid #b8e2c8;
}
.dep-entry-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px 16px;
  align-items: start;
}
.dep-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dep-field label {
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--meta-gray);
}
.dep-req {
  color: var(--red);
  margin-left: 2px;
}
.dep-field input,
.dep-field select {
  height: 2.571rem;
  padding: 0.429rem 0.714rem;
  border: 1px solid var(--line);
  border-radius: 8px;
  font-size: 0.929rem;
  color: #2e2e2e;
  background: #ffffff;
}
.dep-filters .dep-field p-autocomplete {
  display: block;
  width: 100%;
}
.dep-filters ::ng-deep .p-autocomplete {
  width: 100%;
  display: flex;
}
.dep-filters ::ng-deep .p-autocomplete-input {
  width: 100%;
  height: 2rem;
  padding: 5px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #2e2e2e;
  background: #ffffff;
  box-sizing: border-box;
}
.dep-filters ::ng-deep .p-autocomplete-input::placeholder {
  color: #767676;
}
.dep-filters ::ng-deep .p-autocomplete.p-focus .p-autocomplete-input,
.dep-filters ::ng-deep .p-autocomplete-input:focus {
  outline: none;
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.dep-filters ::ng-deep .p-autocomplete-dropdown.p-button {
  background: transparent !important;
  border: 1px solid #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.45) !important;
  width: 2rem;
  box-shadow: none !important;
}
.dep-filters ::ng-deep .p-autocomplete-dropdown.p-button:hover {
  background: transparent !important;
  color: #40a9ff !important;
}
.dep-filters ::ng-deep .p-autocomplete-panel .p-autocomplete-items {
  padding-left: 0;
}
.dep-filters ::ng-deep .p-autocomplete-panel .p-autocomplete-item {
  padding: 5px 12px;
  font-size: 14px;
}
.dep-filters ::ng-deep .p-autocomplete-panel .p-autocomplete-item.p-highlight,
.dep-filters ::ng-deep .p-autocomplete-panel .p-autocomplete-item[data-p-highlight=true] {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  background-color: #e6f7ff;
}
.dep-field input:focus,
.dep-field select:focus {
  outline: none;
  border-color: var(--teal-bright);
  box-shadow: 0 0 0 3px #cff1ef99;
}
.dep-field input.dep-amt {
  font-family: var(--mono-font);
  text-align: right;
}
.dep-field input.dep-invalid {
  border-color: var(--red);
  background: var(--red-bg);
}
.dep-err {
  font-size: 0.714rem;
  font-weight: 600;
  color: var(--red);
  min-height: 1em;
}
.dep-entry-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--line-eee);
  flex-wrap: wrap;
}
.dep-toast {
  margin-left: auto;
  font-size: 0.857rem;
  font-weight: 700;
  color: var(--green);
  background: var(--green-bg);
  border: 1px solid #b8e2c8;
  border-radius: 8px;
  padding: 6px 12px;
}
.dep-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-bottom: 12px;
}
.dep-filters .dep-field {
  min-width: 170px;
}
.dep-empty {
  padding: 24px;
  text-align: center;
  color: var(--meta-gray);
  font-size: 0.929rem;
  margin: 0;
}
.dep-btn:disabled {
  background: var(--line);
  border-color: var(--line);
  color: #8a8a8a;
  cursor: not-allowed;
}
.dep-btn:disabled:hover {
  background: var(--line);
  color: #8a8a8a;
}
::ng-deep ppl-list-table .ghost-button {
  height: 2rem;
  padding: 0 0.714rem;
  border-radius: 8px;
  border: 1px solid var(--line);
  background: #ffffff;
  color: #303030;
  font-size: 0.786rem;
  font-weight: 700;
  white-space: nowrap;
}
::ng-deep ppl-list-table .ghost-button:hover:not(:disabled) {
  background: #303030;
  color: #ffffff;
  border-color: #303030;
}
.dep-modal__crumb {
  font-size: 0.786rem;
  color: var(--teal-head-text);
  margin-bottom: 12px;
  background: var(--teal-pale);
  border-radius: 6px;
  padding: 6px 12px;
  display: inline-block;
}
.dep-modal__body {
  padding: 16px;
  overflow-y: auto;
}
::ng-deep .dep-cash-modal .header {
  background: var(--teal-pale);
}
::ng-deep .dep-cash-modal .title {
  color: var(--teal-head-text);
  font-size: 1.286rem;
}
::ng-deep .dep-cash-modal .title .fa-lightbulb-o {
  display: none;
}
::ng-deep .dep-cash-modal .action-footer.right-aligned-buttons .ghost-button {
  order: 1;
}
::ng-deep .dep-cash-modal .action-footer.right-aligned-buttons .primary-button {
  order: 2;
}
::ng-deep .dep-cash-modal .action-footer .ppl-button,
::ng-deep .dep-cash-modal .action-footer button {
  width: auto;
  min-width: 110px;
}
.dep-kv {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px 20px;
  padding: 12px;
  background: #fafbfc;
  border: 1px solid var(--line-eee);
  border-radius: 6px;
  margin-bottom: 12px;
}
.dep-kv > div {
  font-size: 0.929rem;
}
.dep-kv__k {
  display: block;
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--meta-gray);
}
.dep-kv__v {
  font-weight: 600;
}
.dep-sublabel {
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--meta-gray);
  margin: 14px 0 6px;
}
.dep-hint {
  font-size: 0.786rem;
  color: var(--meta-gray);
}
.dep-export-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  width: 100%;
}
.dep-export-grid .dep-field nz-date-picker,
.dep-export-grid .dep-field ppl-dropdown-select,
.dep-field nz-date-picker {
  width: 100%;
}
.dep-field nz-date-picker.dep-invalid ::ng-deep .ant-picker {
  border-color: var(--red);
  background: var(--red-bg);
}
.dep-icn-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.dep-icn-row .dep-field {
  min-width: 220px;
}
.dep-mono-input {
  font-family: var(--mono-font);
  text-transform: uppercase;
}
.dep-tbl-scroll {
  overflow-x: auto;
}
.dep-tbl-scroll table {
  width: 100%;
  border-collapse: collapse;
}
.dep-tbl-scroll th {
  background: #f1f2f5;
  text-align: left;
  padding: 8px 12px;
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--meta-gray);
  white-space: nowrap;
}
.dep-tbl-scroll td {
  padding: 9px 12px;
  border-bottom: 1px solid var(--line-eee);
  font-size: 0.929rem;
  vertical-align: top;
}
.dep-tbl-scroll tbody tr:nth-child(even) {
  background: #cff1f04d;
}
.dep-num {
  text-align: right;
  white-space: nowrap;
}
.dep-ctr {
  text-align: center;
}
.dep-mono {
  font-family: var(--mono-font);
  font-size: 0.786rem;
  color: #3a3f45;
}
.dep-pay-input {
  width: 120px;
  height: 2.143rem;
  padding: 0.286rem 0.5rem;
  border: 1px solid var(--line);
  border-radius: 8px;
  font-family: var(--mono-font);
  font-size: 0.929rem;
  text-align: right;
}
.dep-pay-input:focus {
  outline: none;
  border-color: var(--teal-bright);
  box-shadow: 0 0 0 3px #cff1ef99;
}
.dep-pay-input.dep-invalid {
  border-color: var(--red);
  background: var(--red-bg);
}
.dep-row-x {
  width: 1.857rem;
  height: 1.857rem;
  border-radius: 8px;
  border: 1px solid var(--line);
  background: #ffffff;
  color: var(--red);
  font-weight: 700;
  cursor: pointer;
  line-height: 1;
}
.dep-row-x:hover {
  background: var(--red-bg);
  border-color: #f3c2bd;
}
.dep-apply-summary {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
  margin-top: 14px;
  padding: 12px;
  background: #fafbfc;
  border: 1px solid var(--line-eee);
  border-radius: 6px;
}
.dep-apply-summary__v--over {
  color: var(--red);
}
@media (max-width: 900px) {
  .dep-head.ppl-container-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .dep-panel__sum {
    margin-left: 0;
    width: 100%;
  }
  .dep-toast {
    margin-left: 0;
  }
}
/*# sourceMappingURL=deposit-entry-list.component-RUC2X7FZ.css.map */
